import { render, staticRenderFns } from "./my-appointDetail.vue?vue&type=template&id=2440414d&scoped=true&"
import script from "./my-appointDetail.vue?vue&type=script&lang=js&"
export * from "./my-appointDetail.vue?vue&type=script&lang=js&"
import style0 from "./my-appointDetail.vue?vue&type=style&index=0&id=2440414d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2440414d",
  null
  
)

component.options.__file = "my-appointDetail.vue"
export default component.exports